import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Container, Segment, Message, Loader } from 'semantic-ui-react';
import { Helmet } from 'react-helmet-async';
import { recipes } from '../services/api';
import RecipeView from '../components/recipe/RecipeView';

function RecipePage() {
  const { id } = useParams();

  const { data: recipe, isLoading, error } = useQuery({
    queryKey: ['recipe', id],
    queryFn: () => recipes.get(id),
    select: (response) => response.data
  });

  return (
    <>
      <Helmet>
        <title>{recipe ? `${recipe.name} - Miakara Soap Recipes` : 'Loading Recipe - Miakara Soap Recipes'}</title>
      </Helmet>
      <Container>
        <Segment vertical>
          {isLoading && <Loader active>Loading Recipe...</Loader>}
          {error && (
            <Message negative>
              <Message.Header>Error Loading Recipe</Message.Header>
              <p>{error.response?.data?.message || 'Failed to load recipe'}</p>
            </Message>
          )}
          {recipe && <RecipeView recipe={recipe} />}
        </Segment>
      </Container>
    </>
  );
}

export default RecipePage; 